"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.badges = exports.BADGE_NAMES = void 0;
exports.getBadgeLevel = getBadgeLevel;
exports.getBadgeMaxLevel = getBadgeMaxLevel;
exports.hasBadge = hasBadge;
const career_1 = require("./career");
const improvement_1 = require("./improvement");
var BADGE_NAMES;
(function (BADGE_NAMES) {
    BADGE_NAMES["BLOODTHIRSTY"] = "bloodthirsty";
    BADGE_NAMES["DEAD_FULL_MOON"] = "dead-full-moon";
    BADGE_NAMES["DEAD"] = "dead";
    BADGE_NAMES["ELVEN_UNION"] = "elfen-union";
    BADGE_NAMES["IMPERIAL"] = "imperial";
    BADGE_NAMES["KILL"] = "kill";
    BADGE_NAMES["NURGLE"] = "nurgle";
    BADGE_NAMES["SNOTLING"] = "snotling";
    BADGE_NAMES["WEAPON"] = "weapon";
    BADGE_NAMES["VAMPIRE"] = "vampire";
    BADGE_NAMES["SLANN"] = "slann";
})(BADGE_NAMES || (exports.BADGE_NAMES = BADGE_NAMES = {}));
const badges = {};
exports.badges = badges;
// "human-career": ranges,
// "orc-career": ranges,
// ...
Object.values((0, career_1.getCareers)()).forEach((r) => {
    if (!badges[r.badge]) {
        badges[r.badge] = [0, ...improvement_1.ranges];
    }
});
badges[BADGE_NAMES.KILL] = [0, 1, 2, 3, 5, 7, 9]; // 10 max
badges[BADGE_NAMES.DEAD] = [0, 1, 2, 3, 5, 7, 9];
badges[BADGE_NAMES.DEAD_FULL_MOON] = [0];
badges[BADGE_NAMES.BLOODTHIRSTY] = [0]; // 1 max
badges[BADGE_NAMES.NURGLE] = [0];
badges[BADGE_NAMES.VAMPIRE] = [0]; // Store
badges[BADGE_NAMES.ELVEN_UNION] = [0]; // Store
badges[BADGE_NAMES.SNOTLING] = [0]; // Store
badges[BADGE_NAMES.IMPERIAL] = [0]; // Store
badges[BADGE_NAMES.SLANN] = [0]; // Store
badges[BADGE_NAMES.WEAPON] = [0];
function getBadgeMaxLevel(badge) {
    return badges[badge.badge_id].length;
}
function getBadgeLevel(badge) {
    const meta = badges[badge.badge_id];
    let level = meta.findIndex((lvl) => badge.quantity <= lvl);
    if (level === -1) {
        return getBadgeMaxLevel(badge);
    }
    return level;
}
function hasBadge(badgeId, user, quantity = 1) {
    const hasBadgeQte = user.badges.find((b) => {
        return b.badge_id === badgeId && b.quantity >= quantity;
    });
    return hasBadgeQte != null;
}
